import { IBrandResponse } from '@/data/brand/types';
import { MaybeType } from '@/types';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

type BrandStore = {
  brand: MaybeType<IBrandResponse> | null;
  setBrand: (brand: MaybeType<IBrandResponse>) => void;
};

export const useBrandStore = create<BrandStore, [['zustand/immer', never], ['zustand/devtools', never]]>(
  immer(
    devtools(
      (set, get): BrandStore => ({
        brand: null,
        setBrand: (brand: MaybeType<IBrandResponse>) => set(state => ({ ...state, brand })),
      }),
    ),
  ),
);
